import { render, staticRenderFns } from "./orderListHis.vue?vue&type=template&id=39f5cbe4&scoped=true&"
import script from "./orderListHis.vue?vue&type=script&lang=js&"
export * from "./orderListHis.vue?vue&type=script&lang=js&"
import style0 from "./orderListHis.vue?vue&type=style&index=0&id=39f5cbe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f5cbe4",
  null
  
)

export default component.exports